module.exports = __webpack_public_path__ + "img/ingreso.37a6c901.svg";